<template>
  <v-dialog v-model="sairDialog" max-width="340" scrollable>
    <v-card>
      <v-card-text class="pa-5">
        <b>Você realmente deseja sair sem salvar as novas configurações?</b>
        <v-card-actions class="pt-3">
          <v-spacer />
          <v-btn @click="sim"> Sim </v-btn>
          <v-btn @click="dialogClose" color="primary"> Não </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    dialog: Boolean,
  },
  data: function () {
    return {
      loading: false,
    };
  },
  computed: {
    sairDialog: {
      get() {
        return this.dialog;
      },
      set() {
        this.dialogClose();
      },
    },
  },
  methods: {
    sim() {
      this.$emit("funcaoSair");
      this.dialogClose();
    },
    dialogClose() {
      this.$emit("dialogClose");
    },
  },
};
</script>
